import { render, staticRenderFns } from "./orderBox.vue?vue&type=template&id=8a50b1e2&scoped=true"
import script from "./orderBox.vue?vue&type=script&lang=js"
export * from "./orderBox.vue?vue&type=script&lang=js"
import style0 from "./orderBox.vue?vue&type=style&index=0&id=8a50b1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a50b1e2",
  null
  
)

export default component.exports